module.exports = __webpack_public_path__ + "img/2020_HH_2019_Kismarosi_előadás1.66290517.jpg";